import { Collapse, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export const PublicationNoItemText = ({
  children,
  show = true,
}: {
  children: ReactNode;
  show?: boolean;
}) => {
  return (
    <Collapse in={show} unmountOnExit>
      <Text fontSize="md" pt={4} px={4} textAlign="center" color="brand.analytic">
        {children}
      </Text>
    </Collapse>
  );
};
